/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../roster/mds_extensions';
import '../taxinator/service';
import '../common/countries';
import '../common/currency';
import '../bills/cart';
import '../common/time';
import '../bills/bill';
import '../common/currency_codes';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "billing": {
        "nested": {
          "data": {
            "nested": {
              "InstrumentType": {
                "values": {
                  "CARD": 0,
                  "BANK_ACCOUNT": 1
                }
              },
              "SubscriptionFeeBillCycle": {
                "values": {
                  "UNKNOWN": 0,
                  "PREPAY_MONTHLY": 1,
                  "FREE": 2,
                  "PAY_AS_YOU_GO_MONTHLY": 3,
                  "PAY_AS_YOU_GO": 4,
                  "POSTPAY_MONTHLY": 5,
                  "ONE_TIME": 6,
                  "PREPAY_YEARLY": 7
                }
              },
              "TaxStatus": {
                "values": {
                  "UNSET": 0,
                  "ESTIMATED": 1,
                  "COMMITTED": 2,
                  "REFUNDED": 3,
                  "MANUAL": 4
                }
              },
              "InstrumentIntent": {
                "values": {
                  "DO_NOT_USE": 0,
                  "PRIMARY": 1,
                  "BACKUP": 2
                }
              },
              "Biller": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Merchant": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantTokenType": {
                    "type": "squareup.roster.mds.MdsTokenType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "sellerCode": {
                    "type": "squareup.taxinator.service.SellerCode",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Payer": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "tokenType": {
                    "type": "squareup.roster.mds.MdsTokenType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "billingAddress": {
                    "type": "squareup.billing.data.PayerBillingAddress",
                    "id": 2,
                    "rule": "optional"
                  },
                  "vatNumber": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "PayerBillingAddress": {
                "fields": {
                  "line1": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "line2": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "city": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "state": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "countryCode": {
                    "type": "squareup.common.countries.Country",
                    "id": 5,
                    "rule": "optional"
                  },
                  "postalCode": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "AdditionalBillInformation": {
                "fields": {
                  "billToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "vatId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "TaxAddress": {
                "fields": {
                  "line1": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "line2": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "city": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "mainDivision": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "subDivision": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "countryCode": {
                    "type": "squareup.common.countries.Country",
                    "id": 6,
                    "rule": "optional"
                  },
                  "postalCode": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "Group": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "threshold": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "thresholds": {
                    "type": "squareup.billing.data.Threshold",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "closeAtEndOfMonth": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "recurringPaymentToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "Threshold": {
                "fields": {
                  "cost": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "Instrument": {
                "fields": {
                  "type": {
                    "type": "squareup.billing.data.InstrumentType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "externalToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "externalTokenType": {
                    "type": "squareup.roster.mds.MdsTokenType",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "Discount": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "configuration": {
                    "type": "squareup.bills.DiscountLineItem.Configuration",
                    "id": 2,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ProductLabel": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cost": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "discountAmount": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "DiscountLabel": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "discountAmount": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "LineItem": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "billerToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "payerToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "payerTokenType": {
                    "type": "squareup.roster.mds.MdsTokenType",
                    "id": 22,
                    "rule": "optional"
                  },
                  "groupToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "billableAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  },
                  "cost": {
                    "type": "squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "quantity": {
                    "type": "int64",
                    "id": 19,
                    "rule": "optional"
                  },
                  "totalCost": {
                    "type": "squareup.common.Money",
                    "id": 15,
                    "rule": "optional"
                  },
                  "taxableCost": {
                    "type": "squareup.common.Money",
                    "id": 16,
                    "rule": "optional"
                  },
                  "taxCost": {
                    "type": "squareup.common.Money",
                    "id": 7,
                    "rule": "optional"
                  },
                  "inclusiveTax": {
                    "type": "squareup.common.Money",
                    "id": 23,
                    "rule": "optional"
                  },
                  "additiveTax": {
                    "type": "squareup.common.Money",
                    "id": 24,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "serviceStartAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 9,
                    "rule": "optional"
                  },
                  "serviceEndAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 10,
                    "rule": "optional"
                  },
                  "discount": {
                    "type": "squareup.billing.data.Discount",
                    "id": 11,
                    "rule": "repeated"
                  },
                  "taxStatus": {
                    "type": "squareup.billing.data.TaxStatus",
                    "id": 12,
                    "rule": "optional"
                  },
                  "taxClass": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "productCode": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "productLabel": {
                    "type": "squareup.billing.data.ProductLabel",
                    "id": 17,
                    "rule": "repeated"
                  },
                  "voided": {
                    "type": "bool",
                    "id": 18,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "refundToken": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  },
                  "billToken": {
                    "type": "string",
                    "id": 25,
                    "rule": "optional"
                  }
                }
              },
              "Bill": {
                "fields": {
                  "paid": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "voided": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "refunded": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "totalCost": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "billedOn": {
                    "type": "squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  },
                  "chargeableAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 11,
                    "rule": "optional"
                  },
                  "productLabel": {
                    "type": "squareup.billing.data.ProductLabel",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "paymentStatus": {
                    "type": "squareup.billing.data.Bill.PaymentStatus",
                    "id": 8,
                    "rule": "optional"
                  },
                  "billerToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "payerToken": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "scheduledCartTokens": {
                    "type": "string",
                    "id": 12,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "PaymentStatus": {
                    "values": {
                      "UNUSED": 0,
                      "UNCHARGED": 1,
                      "UNPAID": 2,
                      "PAID": 3,
                      "VOIDED": 4,
                      "DELINQUENT": 5,
                      "DISPUTED": 6,
                      "REFUNDED": 7
                    }
                  }
                }
              },
              "BillsInTimePeriod": {
                "fields": {
                  "bills": {
                    "type": "squareup.bills.Bill",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "beginTime": {
                    "type": "squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "endTime": {
                    "type": "squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "Amount": {
                "fields": {
                  "amount": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "taxAmount": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "inclusiveTax": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "additiveTax": {
                    "type": "squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "AmountPerBiller": {
                "fields": {
                  "billerToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "billerName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "failedBills": {
                    "type": "squareup.bills.Bill",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              },
              "BillingItemizationData": {
                "fields": {
                  "productLabel": {
                    "type": "squareup.billing.data.ProductLabel",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "discountLabel": {
                    "type": "squareup.billing.data.DiscountLabel",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "Navigation": {
                "fields": {
                  "after": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "BillFeedEntry": {
                "fields": {
                  "id": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "currentChargeAttemptId": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "payerToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "payerTokenType": {
                    "type": "squareup.roster.mds.MdsTokenType",
                    "id": 5,
                    "rule": "optional"
                  },
                  "billerToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "billerName": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "currencyCode": {
                    "type": "squareup.common.CurrencyCode",
                    "id": 8,
                    "rule": "optional"
                  },
                  "totalItemsCostAmount": {
                    "type": "int64",
                    "id": 9,
                    "rule": "optional"
                  },
                  "totalDiscountAmount": {
                    "type": "int64",
                    "id": 10,
                    "rule": "optional"
                  },
                  "totalTaxCostAmount": {
                    "type": "int64",
                    "id": 11,
                    "rule": "optional"
                  },
                  "totalCostAmount": {
                    "type": "int64",
                    "id": 12,
                    "rule": "optional"
                  },
                  "taxIncluded": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional"
                  },
                  "paymentStatus": {
                    "type": "squareup.billing.data.BillFeedEntry.PaymentStatus",
                    "id": 14,
                    "rule": "optional"
                  },
                  "backfillToken": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "scheduledCartTokens": {
                    "type": "string",
                    "id": 16,
                    "rule": "repeated"
                  },
                  "billedOn": {
                    "type": "squareup.common.time.DateTime",
                    "id": 17,
                    "rule": "optional"
                  },
                  "chargeableAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 18,
                    "rule": "optional"
                  },
                  "serviceStartAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 19,
                    "rule": "optional"
                  },
                  "serviceEndAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 20,
                    "rule": "optional"
                  },
                  "sourceBiller": {
                    "type": "string",
                    "id": 21,
                    "rule": "optional"
                  },
                  "originalFeeId": {
                    "type": "int64",
                    "id": 22,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 23,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 24,
                    "rule": "optional"
                  },
                  "remindedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 25,
                    "rule": "optional"
                  },
                  "groupToken": {
                    "type": "string",
                    "id": 26,
                    "rule": "optional"
                  },
                  "productLabels": {
                    "type": "squareup.billing.data.ProductLabel",
                    "id": 27,
                    "rule": "repeated"
                  },
                  "currentChargeStatus": {
                    "type": "string",
                    "id": 28,
                    "rule": "optional"
                  },
                  "instrumentType": {
                    "type": "string",
                    "id": 29,
                    "rule": "optional"
                  },
                  "instrumentToken": {
                    "type": "string",
                    "id": 30,
                    "rule": "optional"
                  },
                  "instrumentExternalToken": {
                    "type": "string",
                    "id": 31,
                    "rule": "optional"
                  },
                  "instrumentExternalTokenType": {
                    "type": "string",
                    "id": 32,
                    "rule": "optional"
                  },
                  "billingCycle": {
                    "type": "squareup.billing.data.SubscriptionFeeBillCycle",
                    "id": 33,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "PaymentStatus": {
                    "values": {
                      "UNUSED": 0,
                      "UNCHARGED": 1,
                      "UNPAID": 2,
                      "PAID": 3,
                      "VOIDED": 4,
                      "DELINQUENT": 5,
                      "DISPUTED": 6,
                      "REFUNDED": 7
                    }
                  }
                }
              },
              "ChargeAttemptFeedEntry": {
                "fields": {
                  "id": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "payerToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "payerTokenType": {
                    "type": "squareup.roster.mds.MdsTokenType",
                    "id": 4,
                    "rule": "optional"
                  },
                  "instrumentId": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "instrumentToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "instrumentExternalToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "instrumentExternalTokenType": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "instrumentType": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "billerToken": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "billerName": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "billId": {
                    "type": "int64",
                    "id": 12,
                    "rule": "optional"
                  },
                  "billToken": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "groupToken": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "currencyCode": {
                    "type": "squareup.common.CurrencyCode",
                    "id": 15,
                    "rule": "optional"
                  },
                  "totalCostAmount": {
                    "type": "int64",
                    "id": 16,
                    "rule": "optional"
                  },
                  "totalItemsCostAmount": {
                    "type": "int64",
                    "id": 17,
                    "rule": "optional"
                  },
                  "totalTaxCostAmount": {
                    "type": "int64",
                    "id": 18,
                    "rule": "optional"
                  },
                  "sourceBiller": {
                    "type": "string",
                    "id": 19,
                    "rule": "optional"
                  },
                  "originalFeeId": {
                    "type": "int64",
                    "id": 20,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "string",
                    "id": 21,
                    "rule": "optional"
                  },
                  "chargeStatus": {
                    "type": "string",
                    "id": 22,
                    "rule": "optional"
                  },
                  "voided": {
                    "type": "bool",
                    "id": 23,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 24,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 25,
                    "rule": "optional"
                  },
                  "notifiedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 26,
                    "rule": "optional"
                  }
                }
              },
              "DiscountFeedEntry": {
                "fields": {
                  "id": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "discountId": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "lineItemId": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "billId": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "billToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "originalFeeId": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "currencyCode": {
                    "type": "squareup.common.CurrencyCode",
                    "id": 9,
                    "rule": "optional"
                  },
                  "fixedPercentage": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "fixedAmount": {
                    "type": "int64",
                    "id": 11,
                    "rule": "optional"
                  },
                  "appliedDiscountAmount": {
                    "type": "int64",
                    "id": 12,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 14,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 15,
                    "rule": "optional"
                  },
                  "deletedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 16,
                    "rule": "optional"
                  }
                }
              },
              "InstrumentFeedEntry": {
                "fields": {
                  "id": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "payerToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "payerTokenType": {
                    "type": "squareup.roster.mds.MdsTokenType",
                    "id": 5,
                    "rule": "optional"
                  },
                  "payerDefaultInstrumentId": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "externalToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "externalTokenType": {
                    "type": "squareup.roster.mds.MdsTokenType",
                    "id": 8,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 9,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 10,
                    "rule": "optional"
                  }
                }
              },
              "LineItemFeedEntry": {
                "fields": {
                  "id": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "payerToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "billerToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "billId": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "billToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "billerName": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "groupId": {
                    "type": "int64",
                    "id": 8,
                    "rule": "optional"
                  },
                  "groupToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "groupName": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "voided": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  },
                  "currencyCode": {
                    "type": "squareup.common.CurrencyCode",
                    "id": 12,
                    "rule": "optional"
                  },
                  "costAmount": {
                    "type": "int64",
                    "id": 13,
                    "rule": "optional"
                  },
                  "quantity": {
                    "type": "int64",
                    "id": 14,
                    "rule": "optional"
                  },
                  "taxCostAmount": {
                    "type": "int64",
                    "id": 15,
                    "rule": "optional"
                  },
                  "taxIncluded": {
                    "type": "bool",
                    "id": 16,
                    "rule": "optional"
                  },
                  "sourceBiller": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "billableAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 18,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 19,
                    "rule": "optional"
                  },
                  "serviceStartAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 20,
                    "rule": "optional"
                  },
                  "serviceEndAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 21,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 22,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 23,
                    "rule": "optional"
                  },
                  "productLabels": {
                    "type": "string",
                    "id": 24,
                    "rule": "optional"
                  },
                  "billingCycle": {
                    "type": "squareup.billing.data.SubscriptionFeeBillCycle",
                    "id": 25,
                    "rule": "optional"
                  }
                }
              },
              "RefundAttemptFeedEntry": {
                "fields": {
                  "id": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "refundId": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "payerToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "instrumentType": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "omnibusBillServerToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "totalRefundAmount": {
                    "type": "int64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "totalRefundCurrencyCode": {
                    "type": "squareup.common.CurrencyCode",
                    "id": 8,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "sourceBiller": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "originalFeeId": {
                    "type": "int64",
                    "id": 11,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 12,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 13,
                    "rule": "optional"
                  }
                }
              },
              "RefundFeedEntry": {
                "fields": {
                  "id": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "billId": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "moneyAmount": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "moneyCurrencyCode": {
                    "type": "squareup.common.CurrencyCode",
                    "id": 4,
                    "rule": "optional"
                  },
                  "taxMoneyAmount": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "taxMoneyCurrencyCode": {
                    "type": "squareup.common.CurrencyCode",
                    "id": 6,
                    "rule": "optional"
                  },
                  "additiveTaxMoneyAmount": {
                    "type": "int64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "additiveTaxMoneyCurrencyCode": {
                    "type": "squareup.common.CurrencyCode",
                    "id": 8,
                    "rule": "optional"
                  },
                  "inclusiveTaxMoneyAmount": {
                    "type": "int64",
                    "id": 9,
                    "rule": "optional"
                  },
                  "inclusiveTaxMoneyCurrencyCode": {
                    "type": "squareup.common.CurrencyCode",
                    "id": 10,
                    "rule": "optional"
                  },
                  "baseRefundMoneyAmount": {
                    "type": "int64",
                    "id": 11,
                    "rule": "optional"
                  },
                  "baseRefundMoneyCurrencyCode": {
                    "type": "squareup.common.CurrencyCode",
                    "id": 12,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "sourceBiller": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "originalFeeId": {
                    "type": "int64",
                    "id": 15,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 16,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 17,
                    "rule": "optional"
                  },
                  "refundCreatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 18,
                    "rule": "optional"
                  },
                  "refundUpdatedAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 19,
                    "rule": "optional"
                  }
                }
              },
              "PaymentInstrument": {
                "fields": {
                  "instrumentType": {
                    "type": "squareup.billing.data.InstrumentType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "instrumentToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "display": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "intent": {
                    "type": "squareup.billing.data.InstrumentIntent",
                    "id": 6,
                    "rule": "optional"
                  },
                  "bankDetails": {
                    "type": "squareup.billing.data.BankPaymentInstrumentDetails",
                    "id": 4
                  },
                  "cardDetails": {
                    "type": "squareup.billing.data.CardPaymentInstrumentDetails",
                    "id": 5
                  }
                },
                "nested": {
                  "instrument_details": {
                    "oneof": ["bankDetails", "cardDetails"]
                  }
                }
              },
              "BankPaymentInstrumentDetails": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "bankName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "accountType": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "accountNumberSuffix": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "webToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "CardPaymentInstrumentDetails": {
                "fields": {
                  "brand": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardholderName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "expirationMonth": {
                    "type": "int32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "expirationYear": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  },
                  "lastFour": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "PaymentPolicy": {
                "fields": {
                  "payerToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "backupPaymentsEnabled": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": true
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.InstrumentType && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.SubscriptionFeeBillCycle && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.TaxStatus && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.InstrumentIntent && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.Biller && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.Merchant && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.Payer && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.PayerBillingAddress && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.AdditionalBillInformation && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.TaxAddress && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.Group && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.Threshold && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.Instrument && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.Discount && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.ProductLabel && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.DiscountLabel && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.LineItem && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.Bill && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.Bill?.nested?.PaymentStatus && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.BillsInTimePeriod && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.Amount && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.AmountPerBiller && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.BillingItemizationData && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.Navigation && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.BillFeedEntry && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.BillFeedEntry?.nested?.PaymentStatus && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.ChargeAttemptFeedEntry && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.DiscountFeedEntry && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.InstrumentFeedEntry && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.LineItemFeedEntry && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.RefundAttemptFeedEntry && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.RefundFeedEntry && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.PaymentInstrument && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.BankPaymentInstrumentDetails && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.CardPaymentInstrumentDetails && !$root.nested?.squareup?.nested?.billing?.nested?.data?.nested?.PaymentPolicy) {
  $root.addJSON(jsonData);
}

/**
 * The type of an Instrument
 *
 * SOURCE InstrumentType @ squareup/billing/data.proto at 18:1
 */
export const InstrumentType = $root.lookupEnum('squareup.billing.data.InstrumentType').values;
/**
 * The billing cycle for a given line item.  Used by reconciliation.
 *
 * SOURCE SubscriptionFeeBillCycle @ squareup/billing/data.proto at 31:1
 */
export const SubscriptionFeeBillCycle = $root.lookupEnum('squareup.billing.data.SubscriptionFeeBillCycle').values;
/**
 * The state of the tax_cost of a LineItem, which should be in sync with the status in
 * https://git.sqcorp.co/projects/SQ/repos/billing/browse/app/models/line_item.rb#21
 *
 * SOURCE TaxStatus @ squareup/billing/data.proto at 46:1
 */
export const TaxStatus = $root.lookupEnum('squareup.billing.data.TaxStatus').values;
/**
 * The intent of the instrument set by the payer. This dictates the order in which the instruments are used to pay.
 * The primary instrument is the first instrument used to pay, the backup instrument is used if the primary instrument fails,
 * and the unused instrument will not be used to pay even if PRIMARY and BACKUP fails.
 *
 * SOURCE InstrumentIntent @ squareup/billing/data.proto at 70:1
 */
export const InstrumentIntent = $root.lookupEnum('squareup.billing.data.InstrumentIntent').values;
/**
 * An entity that can charge Payers
 *
 * SOURCE Biller @ squareup/billing/data.proto at 83:1
 */
export const Biller = $root.lookupType('squareup.billing.data.Biller');
fixType(Biller, {
  token: {
    required: true
  }
});
Builder.createAndAttachToType(Biller);
/**
 * An entity that can pay out for a biller.  These are not related to merchants in the
 * user model.
 *
 * SOURCE Merchant @ squareup/billing/data.proto at 94:1
 */
export const Merchant = $root.lookupType('squareup.billing.data.Merchant');
fixType(Merchant, {
  merchantToken: {
    required: true
  }
});
Builder.createAndAttachToType(Merchant);
/**
 * An entity that can be billed
 *
 * SOURCE Payer @ squareup/billing/data.proto at 109:1
 */
export const Payer = $root.lookupType('squareup.billing.data.Payer');
fixType(Payer, {
  token: {
    required: true
  }
});
Builder.createAndAttachToType(Payer);
/**
 * SOURCE PayerBillingAddress @ squareup/billing/data.proto at 126:1
 */
export const PayerBillingAddress = $root.lookupType('squareup.billing.data.PayerBillingAddress');
fixType(PayerBillingAddress, {
  countryCode: {
    required: true
  }
});
Builder.createAndAttachToType(PayerBillingAddress);
/**
 * This is used when we return an 'orders' bill proto (Squareup::Bills::Bill) which does not have the below fields
 *
 * SOURCE AdditionalBillInformation @ squareup/billing/data.proto at 145:1
 */
export const AdditionalBillInformation = $root.lookupType('squareup.billing.data.AdditionalBillInformation');
fixType(AdditionalBillInformation);
Builder.createAndAttachToType(AdditionalBillInformation);
/**
 * SOURCE TaxAddress @ squareup/billing/data.proto at 153:1
 */
export const TaxAddress = $root.lookupType('squareup.billing.data.TaxAddress');
fixType(TaxAddress, {
  countryCode: {
    required: true
  }
});
Builder.createAndAttachToType(TaxAddress);
/**
 * A group to put line items in
 *
 * SOURCE Group @ squareup/billing/data.proto at 176:1
 */
export const Group = $root.lookupType('squareup.billing.data.Group');
fixType(Group, {
  token: {
    required: true
  }
});
Builder.createAndAttachToType(Group);
/**
 * A threshold for a group
 *
 * SOURCE Threshold @ squareup/billing/data.proto at 198:1
 */
export const Threshold = $root.lookupType('squareup.billing.data.Threshold');
fixType(Threshold);
Builder.createAndAttachToType(Threshold);
/**
 * An instrument used by a payer
 *
 * SOURCE Instrument @ squareup/billing/data.proto at 206:1
 */
export const Instrument = $root.lookupType('squareup.billing.data.Instrument');
fixType(Instrument, {
  type: {
    required: true
  }
});
Builder.createAndAttachToType(Instrument);
/**
 * SOURCE Discount @ squareup/billing/data.proto at 218:1
 */
export const Discount = $root.lookupType('squareup.billing.data.Discount');
fixType(Discount, {
  token: {
    required: true
  },
  configuration: {
    required: true
  }
});
Builder.createAndAttachToType(Discount);
/**
 * A summary of the product being billed for.
 *
 * SOURCE ProductLabel @ squareup/billing/data.proto at 231:1
 */
export const ProductLabel = $root.lookupType('squareup.billing.data.ProductLabel');
fixType(ProductLabel, {
  name: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ProductLabel);
/**
 * A summary of the product discounts being billed for.
 *
 * SOURCE DiscountLabel @ squareup/billing/data.proto at 244:1
 */
export const DiscountLabel = $root.lookupType('squareup.billing.data.DiscountLabel');
fixType(DiscountLabel, {
  name: {
    notEmpty: true
  },
  discountAmount: {
    required: true
  }
});
Builder.createAndAttachToType(DiscountLabel);
/**
 * An individual line item to be added to a bill
 *
 * SOURCE LineItem @ squareup/billing/data.proto at 254:1
 */
export const LineItem = $root.lookupType('squareup.billing.data.LineItem');
fixType(LineItem, {
  token: {
    required: true
  },
  billerToken: {
    required: true
  },
  payerToken: {
    required: true
  },
  billableAt: {
    required: true
  },
  cost: {
    required: true
  },
  quantity: {
    required: true
  }
});
Builder.createAndAttachToType(LineItem);
/**
 * A collection of line items billed together
 *
 * SOURCE Bill @ squareup/billing/data.proto at 335:1
 */
export const Bill = $root.lookupType('squareup.billing.data.Bill');
fixType(Bill, {
  paid: {
    required: true
  },
  voided: {
    required: true
  },
  refunded: {
    required: true
  },
  totalCost: {
    required: true
  },
  token: {
    required: true
  }
});
Builder.createAndAttachToType(Bill);
/**
 * SOURCE PaymentStatus @ squareup/billing/data.proto at 361:3
 */
Bill.PaymentStatus = $root.lookupEnum('squareup.billing.data.Bill.PaymentStatus').values;
/**
 * A collection of bills in the time period specified by the begin and end time
 *
 * SOURCE BillsInTimePeriod @ squareup/billing/data.proto at 404:1
 */
export const BillsInTimePeriod = $root.lookupType('squareup.billing.data.BillsInTimePeriod');
fixType(BillsInTimePeriod, {
  beginTime: {
    required: true
  },
  endTime: {
    required: true
  }
});
Builder.createAndAttachToType(BillsInTimePeriod);
/**
 * A summary field for both the cost amount and tax amount
 *
 * SOURCE Amount @ squareup/billing/data.proto at 418:1
 */
export const Amount = $root.lookupType('squareup.billing.data.Amount');
fixType(Amount, {
  amount: {
    required: true
  }
});
Builder.createAndAttachToType(Amount);
/**
 * The Biller token and amount for each Biller who has a contract with the Payer
 *
 * SOURCE AmountPerBiller @ squareup/billing/data.proto at 434:1
 */
export const AmountPerBiller = $root.lookupType('squareup.billing.data.AmountPerBiller');
fixType(AmountPerBiller, {
  billerToken: {
    required: true
  },
  amount: {
    required: true
  },
  billerName: {
    required: true
  },
  failedBills: {
    required: true
  }
});
Builder.createAndAttachToType(AmountPerBiller);
/**
 * Message containing all the data for billing injected on a Cart Itemization.
 *
 * SOURCE BillingItemizationData @ squareup/billing/data.proto at 450:1
 */
export const BillingItemizationData = $root.lookupType('squareup.billing.data.BillingItemizationData');
fixType(BillingItemizationData);
Builder.createAndAttachToType(BillingItemizationData);
/**
 * SOURCE Navigation @ squareup/billing/data.proto at 459:1
 */
export const Navigation = $root.lookupType('squareup.billing.data.Navigation');
fixType(Navigation);
Builder.createAndAttachToType(Navigation);
/**
 * The feed entry representation of a Bill
 *
 * SOURCE BillFeedEntry @ squareup/billing/data.proto at 465:1
 */
export const BillFeedEntry = $root.lookupType('squareup.billing.data.BillFeedEntry');
fixType(BillFeedEntry);
Builder.createAndAttachToType(BillFeedEntry);
/**
 * SOURCE PaymentStatus @ squareup/billing/data.proto at 508:3
 */
BillFeedEntry.PaymentStatus = $root.lookupEnum('squareup.billing.data.BillFeedEntry.PaymentStatus').values;
/**
 * SOURCE ChargeAttemptFeedEntry @ squareup/billing/data.proto at 598:1
 */
export const ChargeAttemptFeedEntry = $root.lookupType('squareup.billing.data.ChargeAttemptFeedEntry');
fixType(ChargeAttemptFeedEntry);
Builder.createAndAttachToType(ChargeAttemptFeedEntry);
/**
 * SOURCE DiscountFeedEntry @ squareup/billing/data.proto at 680:1
 */
export const DiscountFeedEntry = $root.lookupType('squareup.billing.data.DiscountFeedEntry');
fixType(DiscountFeedEntry);
Builder.createAndAttachToType(DiscountFeedEntry);
/**
 * SOURCE InstrumentFeedEntry @ squareup/billing/data.proto at 731:1
 */
export const InstrumentFeedEntry = $root.lookupType('squareup.billing.data.InstrumentFeedEntry');
fixType(InstrumentFeedEntry);
Builder.createAndAttachToType(InstrumentFeedEntry);
/**
 * SOURCE LineItemFeedEntry @ squareup/billing/data.proto at 765:1
 */
export const LineItemFeedEntry = $root.lookupType('squareup.billing.data.LineItemFeedEntry');
fixType(LineItemFeedEntry);
Builder.createAndAttachToType(LineItemFeedEntry);
/**
 * SOURCE RefundAttemptFeedEntry @ squareup/billing/data.proto at 843:1
 */
export const RefundAttemptFeedEntry = $root.lookupType('squareup.billing.data.RefundAttemptFeedEntry');
fixType(RefundAttemptFeedEntry);
Builder.createAndAttachToType(RefundAttemptFeedEntry);
/**
 * SOURCE RefundFeedEntry @ squareup/billing/data.proto at 885:1
 */
export const RefundFeedEntry = $root.lookupType('squareup.billing.data.RefundFeedEntry');
fixType(RefundFeedEntry);
Builder.createAndAttachToType(RefundFeedEntry);
/**
 * SOURCE PaymentInstrument @ squareup/billing/data.proto at 945:1
 */
export const PaymentInstrument = $root.lookupType('squareup.billing.data.PaymentInstrument');
fixType(PaymentInstrument);
Builder.createAndAttachToType(PaymentInstrument);
/**
 * SOURCE BankPaymentInstrumentDetails @ squareup/billing/data.proto at 967:1
 */
export const BankPaymentInstrumentDetails = $root.lookupType('squareup.billing.data.BankPaymentInstrumentDetails');
fixType(BankPaymentInstrumentDetails);
Builder.createAndAttachToType(BankPaymentInstrumentDetails);
/**
 * SOURCE CardPaymentInstrumentDetails @ squareup/billing/data.proto at 981:1
 */
export const CardPaymentInstrumentDetails = $root.lookupType('squareup.billing.data.CardPaymentInstrumentDetails');
fixType(CardPaymentInstrumentDetails);
Builder.createAndAttachToType(CardPaymentInstrumentDetails);
/**
 * SOURCE PaymentPolicy @ squareup/billing/data.proto at 995:1
 */
export const PaymentPolicy = $root.lookupType('squareup.billing.data.PaymentPolicy');
fixType(PaymentPolicy);
Builder.createAndAttachToType(PaymentPolicy);